export default {
	namespace: 'default',
	beforeEnter() {

	},
	afterEnter() {
		console.log('View: default')
	},
	beforeLeave() {

	},
	afterLeave() {

	}
}
